import PageLayout from "../../layouts/PageLayout"
import HeroHeader from "../../components/HeroHeader"
import Background from "../../assets/FaqHeader.jpg"
import QuestionAnswerList from "./components/QuestionAnswerList"

const FAQs = () => (
    <PageLayout
        hero={
            <HeroHeader
                background={Background}
                backgroundPosition="center right"
                overline="Help & guidance"
                title="FAQs"
                subtitle="Common questions about Private Hire vehicle hire, licensing, insurance, and collecting from our Blaydon office."
                cta={{
                    label: "View questions",
                    onClick: () =>
                        document.getElementById("faq-list")?.scrollIntoView({ behavior: "smooth" }),
                }}
            />
        }
    >
        <QuestionAnswerList />
    </PageLayout>
)

export default FAQs
